import React from "react"
import { graphql } from "gatsby";
import { Seo } from '~/components/shared/seo'
import FaqItem from '~/components/pages/faqItem'
import { notBlank, imgSize } from '~/utils/helpers'

import * as styles from "~/styles/pages/faq.module.scss"



const Faq = ({ data: { faq } }) => {
  const page = faq.data
  const phone_format = page.telephone.replace('(', '').replace(')', '').replace(' ', '-')
  const orders_qas = page.blocks.filter( x => x.group === 'orders-shipping-returns' )
  const retail_qas = page.blocks.filter( x => x.group === 'retail-sizing' )
  const other_qas = page.blocks.filter( x => x.group === 'other' )

  return (
    <>
      <div id="faq-hero" className={styles.hero}>
        {notBlank(page.image) && (
          <div style={{backgroundImage: `url(${imgSize(page.image,1200)})`}} className={styles.image}></div>
        )}
        {notBlank(page.title) && (
          <h1 className={styles.title}>
            {page.title}
          </h1>
        )}
      </div>

      <section className={styles.help}>
        <div>
          <p>Contact Us At</p>
          {notBlank(page.email) && (
            <p>
              <a href={`mailto:${page.email}`} target="_top">
                {page.email}
              </a>
            </p>
          )}
          {notBlank(page.telephone) && (
            <p>
              <a href={`tel:${phone_format}`}  target="_top">
                {phone_format}
              </a>
            </p>
          )}
        </div>

        <div>
          {notBlank(page.hours) && (
            <div dangerouslySetInnerHTML={{ __html: page.hours }} />
          )}
        </div>
      </section>

      <section id="faq" className={styles.faq} itemScope itemType="https://schema.org/FAQPage">
        <h2 className={styles.title}>Orders Shipping & Returns</h2>
        <ul className={styles.faq_items}>
          {orders_qas.map( (json_obj, index) => <FaqItem key={`faq1-${index}`} index={index} content={json_obj} /> )}
        </ul>

        <h2 className={styles.title}>Retail & Sizing</h2>
        <ul className={styles.faq_items}>
          {retail_qas.map( (json_obj, index) => <FaqItem key={`faq2-${index}`} index={index} content={json_obj} /> )}
        </ul>

        <h2 className={styles.title}>Other FAQs</h2>
        <ul className={styles.faq_items}>
          {other_qas.map( (json_obj, index) => <FaqItem key={`faq3-${index}`} index={index} content={json_obj} /> )}
        </ul>
      </section>
    </>
  )
}
export default Faq


export const Head = ({ data: { faq } }) => (
  <Seo 
    title={'FAQ'}
    description={`Frequently asked questions and return policy`}
    image={faq.data.metaimg}
    url={`/pages/faq`}
  />
)



export const pageQuery = graphql`
  {
    faq: contentPage(type: {eq: "Faq"}) {
      data
    }
  }
`;

